import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SeatMapModuleState, seatMapFeatureName } from '@seat-map/store/state/seat-map-module.state';

export const seatMapRootSelector = createFeatureSelector<SeatMapModuleState>(seatMapFeatureName);

export const seatMapSelector = createSelector(seatMapRootSelector,
  (state: SeatMapModuleState) => state.seatMap);

